document.addEventListener('DOMContentLoaded', function () {
  // Update cart button state based on availability
  function updateAvailabilityButtons(btnParent, isAvailable) {
    if (!btnParent) return;
    const cartBtn = btnParent.querySelector('.atc-dropdown .js-grid-cart');
    if (!cartBtn) return;
    const textSpan = cartBtn.querySelector('span:first-child');
    const buyText = cartBtn.getAttribute('data-buy-text') || 'Buy Now';

    if (isAvailable === false || isAvailable === 'false') {
      cartBtn.classList.add('disabled');
      if (textSpan) textSpan.textContent = 'Sold Out';
    } else {
      cartBtn.classList.remove('disabled');
      if (textSpan) textSpan.textContent = buyText;
    }
  }

  // Initialize button state for all product pickers on page load
  document.querySelectorAll('.hss-product-picker').forEach(function (picker) {
    const activeColour = picker.querySelector('.hss-colour-item.active') || picker.querySelector('.hss-colour-item');
    if (!activeColour) return;
    const isAvailable = activeColour.getAttribute('data-available');
    const btnParent = picker.querySelector('.hss-btn-parent');
    updateAvailabilityButtons(btnParent, isAvailable);
  });

  // Function to handle color item selection
  function handleColorItemSelection(colourItem) {
    if (!colourItem) return;

    // Remove active class from all siblings
    const siblings = Array.from(colourItem.parentNode.querySelectorAll('.hss-colour-item'));
    siblings.forEach(sibling => sibling.classList.remove('active'));

    // Add active class to the clicked item
    colourItem.classList.add('active');
  }

  document.addEventListener('click', function (event) {
    // Check if a color item was clicked
    if (event.target.classList.contains('hss-colour-item') || event.target.closest('.hss-colour-item')) {
      // Get the color item element
      const colourItem = event.target.classList.contains('hss-colour-item')
        ? event.target
        : event.target.closest('.hss-colour-item');

      // Handle the color item selection
      handleColorItemSelection(colourItem);

      // Extract only the data attributes we need
      const newColor = colourItem.getAttribute('data-color');
      const newImage1 = colourItem.getAttribute('data-dev-image-1');
      const newProductId = colourItem.getAttribute('data-product-id');
      const isAvailable = colourItem.getAttribute('data-available');
      const productUrl = colourItem.getAttribute('data-product-url');

      // Find the product picker container
      const productPicker = colourItem.closest('.hss-product-picker');
      if (!productPicker) return;

      if (productUrl) {
        productPicker.querySelector('.hs-product-image-link').setAttribute('href', productUrl);
      }

      // Find the product-picker container
      const container = colourItem.closest('.product-picker');
      if (!container) return;

      // Update product image
      if (newImage1) {
        const productImage = container.querySelector('.hs-product-image img');
        if (productImage) {
          productImage.src = newImage1;
          productImage.setAttribute('data-src', newImage1);
        }
      }

      // Update variant name
      const variantNameElement = container.querySelector('.variant-name');
      if (variantNameElement && newColor) {
        variantNameElement.textContent = newColor;
      }

      // Parse variants data
      let variants = [];
      try {
        const variantsAttr = colourItem.getAttribute('data-variants');
        if (variantsAttr) {
          variants = JSON.parse(variantsAttr);
          console.log('Parsed variants:', variants);
        }
      } catch (e) {
        console.error('Error parsing variants data:', e);
      }

      // Find the first available variant ID
      let firstAvailableVariantId = null;
      if (Array.isArray(variants)) {
        for (const variant of variants) {
          if (variant.available) {
            firstAvailableVariantId = variant.id;
            break;
          }
        }
      }

      // Find the ATC button in the hss-btn-parent
      const btnParent = productPicker.querySelector('.hss-btn-parent');
      if (!btnParent) return;

      // Update the ATC button with the first available variant ID (not product ID)
      const atcDropdownButton = btnParent.querySelector('.atc-dropdown .js-grid-cart');
      if (atcDropdownButton && firstAvailableVariantId) {
        atcDropdownButton.setAttribute('data-id', String(firstAvailableVariantId));
      }

      // Find and update the variant dropdown in the atc-dropdown
      const atcDropdown = btnParent.querySelector('.atc-dropdown');
      if (atcDropdown) {
        // First try to find by class
        let variantDropdown = atcDropdown.querySelector('.dropdown-btn');

        // If not found by class, try to find by ID pattern
        if (!variantDropdown) {
          variantDropdown = atcDropdown.querySelector('select[id^="variantDropdown"]');
        }

        if (variantDropdown) {
          // Clear existing options
          variantDropdown.innerHTML = '';

          // Populate with new options
          if (Array.isArray(variants)) {
            variants.forEach(function (variant) {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;

              if (!variant.available) {
                option.disabled = true;
              }

              variantDropdown.appendChild(option);
            });

            // Set the first available variant as selected
            if (firstAvailableVariantId) {
              variantDropdown.value = firstAvailableVariantId;
            }
          }
        }
      }
      updateAvailabilityButtons(btnParent, isAvailable);

      // Reset image index when switching colour products
      const imageContainer = colourItem.closest('.product-picker');
      if (imageContainer) imageContainer.setAttribute('data-image-index', '0');

    }

    // When a colour item is clicked, also update the variant listbox panel with the new product's variants
    if (event.target.classList.contains('hss-colour-item') || event.target.closest('.hss-colour-item')) {
      const colourItem = event.target.classList.contains('hss-colour-item')
        ? event.target
        : event.target.closest('.hss-colour-item');

      const productUrl = colourItem.getAttribute('data-product-url');
      const productPicker = colourItem.closest('.hss-product-picker');
      if (!productPicker) return;

      // Update hs-product-info-link href with new product URL
      const infoLink = productPicker.querySelector('.hs-product-info-link');
      if (infoLink && productUrl) {
        infoLink.setAttribute('href', productUrl);
      }

      // Update variants in the listbox panel
      let variants = [];
      try {
        const variantsAttr = colourItem.getAttribute('data-variants');
        if (variantsAttr) variants = JSON.parse(variantsAttr);
      } catch (e) {}

      if (variants.length > 0) {
        const variantListbox = productPicker.querySelector('.variant-listbox');
        if (variantListbox) {
          // Fully rebuild to correctly handle products with different variant counts
          variantListbox.innerHTML = '';
          variants.forEach(function(variant, index) {
            const li = document.createElement('li');
            li.className = 'variant-listbox__option' + (index === 0 ? ' is-selected' : '');
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
            li.setAttribute('data-variant-id', String(variant.id));
            li.setAttribute('tabindex', index === 0 ? '0' : '-1');
            const sizeSpan = document.createElement('span');
            sizeSpan.className = 'variant-listbox__size';
            sizeSpan.textContent = variant.title;
            li.appendChild(sizeSpan);
            const statusSpan = document.createElement('span');
            statusSpan.className = 'variant-listbox__status ' +
              (variant.available ? 'variant-listbox__status--in-stock' : 'variant-listbox__status--waitlist');
            statusSpan.textContent = variant.available ? 'In Stock' : 'Waitlist';
            li.appendChild(statusSpan);
            variantListbox.appendChild(li);
          });
        }
      }
    }
  });

  // Handle slider arrow navigation — cycles through all images of the active product
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('slider-arrow') || event.target.closest('.slider-arrow')) {
      const sliderArrow = event.target.classList.contains('slider-arrow')
        ? event.target
        : event.target.closest('.slider-arrow');

      const container = sliderArrow.closest('.product-picker');
      if (!container) return;

      // Get the active colour item to read its image list
      const activeColour = container.querySelector('.hss-colour-item.active') || container.querySelector('.hss-colour-item');
      if (!activeColour) return;

      let images = [];
      try {
        const imagesAttr = activeColour.getAttribute('data-images');
        if (imagesAttr) images = JSON.parse(imagesAttr);
      } catch (e) {}

      if (images.length <= 1) return;

      let currentIndex = parseInt(container.getAttribute('data-image-index') || '0', 10);

      if (sliderArrow.classList.contains('prev')) {
        currentIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
      } else if (sliderArrow.classList.contains('next')) {
        currentIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
      }

      container.setAttribute('data-image-index', String(currentIndex));

      const productImage = container.querySelector('.hs-product-image img');
      if (productImage) {
        productImage.src = images[currentIndex];
        productImage.setAttribute('data-src', images[currentIndex]);
      }

      event.stopPropagation();
    }
  });
});

const quickviewBtnSelector = '.hss-btn-quickview';
const quickview = document.querySelector('#customQuickview');
const overlay = document.querySelector('.hss-overlay-bottom-sheet');

document.addEventListener('click', function (event) {
  const quickviewBtn = event.target.closest(quickviewBtnSelector);
  if (quickviewBtn) {
    overlay.classList.add('active');
    quickview.classList.add('active');
    quickview.style.transform = 'translateY(0)'; // RESET transform on open
    quickview.style.transition = 'bottom 0.3s ease-in-out, transform 0.25s ease';
    document.body.style.overflow = 'hidden';
  }
});

// Drag-to-close
let startY = 0;
let currentY = 0;
let translateY = 0;
let isDragging = false;
let animationFrame;

function updateTranslate() {
  quickview.style.transform = `translateY(${translateY}px)`;
  animationFrame = null;
}

quickview.addEventListener('touchstart', (e) => {
  startY = e.touches[0].clientY;
  isDragging = true;
  quickview.style.transition = 'none'; // Disable transition during drag
});

quickview.addEventListener('touchmove', (e) => {
  if (!isDragging) return;
  currentY = e.touches[0].clientY;
  let diffY = currentY - startY;
  translateY = Math.max(0, diffY);
  if (!animationFrame) {
    animationFrame = requestAnimationFrame(updateTranslate);
  }
});

quickview.addEventListener('touchend', () => {
  isDragging = false;
  quickview.style.transition = 'transform 0.25s ease';

  if (translateY > 100) {
    quickview.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  } else {
    quickview.style.transform = 'translateY(0)';
  }

  translateY = 0;
  animationFrame = null;
});

// Overlay click to close
overlay.addEventListener('click', () => {
  quickview.classList.remove('active');
  overlay.classList.remove('active');
  document.body.style.overflow = '';
});
